import { getAppConfig } from '@services/config';
import { cmsHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

import { OdrMapper } from '@mappers/odr';

import { Odr, OdrApiData, OdrApiResponse } from '@app-types/odr';

const appConfig = getAppConfig();

class OdrRepository {
    private readonly baseUrl: string;

    public constructor(adminUrl: string) {
        this.baseUrl = adminUrl;
    }

    public async findById(id: string): Promise<Odr | undefined> {
        try {
            const response = await cmsHttpService.get<OdrApiData>(`${this.baseUrl}/${id}?filterByKey=id`, undefined, {
                ttl: Number.parseInt(appConfig.cache.ttl.odr),
                tags: [CACHE_TAGS.ODR],
            });
            return OdrMapper.apiToOdr(response);
        } catch {
            return undefined;
        }
    }

    public async findAll(): Promise<Odr[]> {
        const odrResponse = await cmsHttpService.get<OdrApiResponse>(`${this.baseUrl}`, undefined, {
            ttl: Number.parseInt(appConfig.cache.ttl.odr),
            tags: [CACHE_TAGS.ODR],
        });
        return OdrMapper.apiListToOdrList(odrResponse.items);
    }

    public async findByUniverse(universeIds: string[]): Promise<Odr[]> {
        if (universeIds.length === 0) {
            return this.findAll();
        }

        const allOdrs = await this.findAll();
        return allOdrs.filter((odr) => universeIds.includes(odr.universeId));
    }
}

export const odrRepository = new OdrRepository(appConfig.odr.adminUrl);
